import React, { useEffect, useMemo, useState } from "react";

import { Stack } from "react-bootstrap";

import { confirmResetPassword, resetPassword } from "@aws-amplify/auth";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";

import { RegisterPageOutline } from "../../register/RegisterPageOutline";
import { BackToSignInButton } from "../BackToSignInButton";
import { ResendCodeButton } from "../ResendCodeButton";

import styles from "./ForgotPassword.module.scss";

export const ForgotPassword = () => {
  const [userEmail, setUserEmail] = useState<string>("");
  const { toForgotPassword, route } = useAuthenticator();

  const navigate = useNavigate();

  const RenderBackButton = useMemo(() => {
    return function Footer() {
      if (route === "confirmResetPassword") {
        return <ResendCodeButton username={userEmail} />;
      }
      return route === "forgotPassword" ? <BackToSignInButton /> : <></>;
    };
  }, [route, userEmail]);

  useEffect(() => {
    // Force the authenticator to show forgot password screen
    toForgotPassword();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack className={styles["forgot-password-container"]} direction="horizontal">
      <RegisterPageOutline showLogIn displayNavigator>
        <div className={window.navigator.userAgent.includes("Windows") ? "amplify" : ""}>
          <Authenticator
            initialState="forgotPassword"
            formFields={{
              confirmResetPassword: {
                confirmation_code: {
                  placeholder: "",
                  label: "Confirmation Code",
                  maxLength: 6,
                },
              },
            }}
            components={{
              Footer: RenderBackButton,
            }}
            services={{
              async handleForgotPassword(formData) {
                setUserEmail(formData.username);
                return resetPassword({ ...formData });
              },
              async handleForgotPasswordSubmit(formData) {
                try {
                  // call the default handleForgotPasswordSubmit
                  await confirmResetPassword(formData);

                  // after successful password reset, navigate to your desired route
                  navigate("/signin");
                } catch (error) {
                  if (error && typeof error === "string") {
                    if (error.includes("CodeMismatchException")) {
                      throw new Error("The verification code is incorrect. Please check and try again.");
                    }
                  }
                  console.error("Error during password reset:", error);
                  throw error;
                }
              },
            }}
          ></Authenticator>
        </div>
      </RegisterPageOutline>
    </Stack>
  );
};
